import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HomeService } from '../service/home.service';

@Component({
  selector: 'app-terms-condition',
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.scss']
})
export class TermsConditionComponent implements OnInit {
  terms: any;

  constructor(private homeService:HomeService,@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<any>) { }

  ngOnInit(): void {
    this.getTerms();
  }

  getTerms(){
    this.homeService.GetTerms({TransactionHeadId: this.data['transId']}).subscribe((brands:any) => {
      if (brands['Success']) {
        this.formatTerms(brands['Result'])
      }
    }); 
  }

  formatTerms(list) {
    // let a = [{ "IsAgree": null, "TermsId": 1, "ListNumber": 1, "SubListNumber": 0, "TermsDescription": "This is a smaple Terms", "TermsDescriptionOtherLanguage": "This is a smaple Terms", "IsActive": true }, { "IsAgree": null, "TermsId": 4, "ListNumber": 1, "SubListNumber": 1, "TermsDescription": "This is a smaple Terms Detail", "TermsDescriptionOtherLanguage": "This is a smaple Terms", "IsActive": true }, { "IsAgree": null, "TermsId": 7, "ListNumber": 2, "SubListNumber": 0, "TermsDescription": "Sample Line2", "TermsDescriptionOtherLanguage": "Sample Line2", "IsActive": true }, { "IsAgree": null, "TermsId": 8, "ListNumber": 2, "SubListNumber": 1, "TermsDescription": "Sample Line2 Sub Line1", "TermsDescriptionOtherLanguage": "Sample Line2 Sub Line1", "IsActive": true }, { "IsAgree": null, "TermsId": 9, "ListNumber": 2, "SubListNumber": 2, "TermsDescription": "Sample Line2 Sub Line2", "TermsDescriptionOtherLanguage": "Sample Line2 Sub Line2", "IsActive": true }, { "IsAgree": null, "TermsId": 10, "ListNumber": 2, "SubListNumber": 3, "TermsDescription": "Sample Line2 Sub Line3", "TermsDescriptionOtherLanguage": "Sample Line2 Sub Line3", "IsActive": true }, { "IsAgree": null, "TermsId": 11, "ListNumber": 3, "SubListNumber": 0, "TermsDescription": "Sample Line3", "TermsDescriptionOtherLanguage": "Sample Line3", "IsActive": true }]
    let output = [];
    var counter = -1;   //ele['ListNumber']  ==>> counter
    var listnumber = -1;
    var lastlistnumber = '';
    list.forEach((ele) => {

      if (lastlistnumber != ele['ListNumber']) {
        lastlistnumber = ele['ListNumber'];
        counter = counter + 1;
      }


      if (ele['SubListNumber'] == 0) {
        let temp = {};
        if (ele != null) {
          console.log('sssssssssssss', ele)
          temp['TermsDescription'] = ele['TermsDescription'];
          temp['TermsDescriptionOtherLanguage'] = ele['TermsDescriptionOtherLanguage'];
          temp['Children'] = [];
          output[counter] = temp;
        }
      }
      else {
        let temp = {};
        console.log('bbbbbbbbbbbbbbb', ele)
        if (ele != null) {
          temp['TermsDescription'] = ele['TermsDescription'];
          temp['TermsDescriptionOtherLanguage'] = ele['TermsDescriptionOtherLanguage'];
          output[counter]['Children'].push(temp)
        }
      }
    })
    console.log('output...', output)

    this.terms = output;

    console.log('terms::', this.terms);
  }

}
